"use client"
import { create } from "zustand"

interface MedicalCategoryState {
  categories: any[]
  category: any | null
  error: string | null
  loading: boolean

  fetchCategories: () => Promise<void>
  fetchCategory: (slug: string) => Promise<void>
}

export const useMedicalCategoryStore = create<MedicalCategoryState>((set) => ({
  categories: [],
  category: null,
  error: null,
  loading: false,

  //------------------------------------
  // 📌 Fetch ALL medical categories
  //------------------------------------
  fetchCategories: async () => {
    set({ loading: true, error: null })
    try {
      const res = await fetch(
        `${process.env.NEXT_PUBLIC_API_URL}medical-category`
      )
      if (!res.ok) throw new Error("Failed to fetch medical categories")

      const data = await res.json()
      set({ categories: data })
    } catch (err: any) {
      set({ error: err.message })
    } finally {
      set({ loading: false })
    }
  },

  //------------------------------------
  // 📌 Fetch ONE medical category
  //------------------------------------
  fetchCategory: async (slug: string) => {
    set({ loading: true, error: null })
    try {
      const res = await fetch(
        `${process.env.NEXT_PUBLIC_API_URL}medical-category`
      )
      if (!res.ok) throw new Error("Failed to fetch medical category")

      const data = await res.json()
      const myCategory=data.filter((x :any)=>x.slug==slug)[0]
      console.log("my myCategory ",myCategory);
      set({ category: myCategory })
    } catch (err: any) {
      set({ error: err.message })
    } finally {
      set({ loading: false })
    }
  },
}))
